import React, { useState, useEffect } from "react";
import {
  Drawer,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Input,
  Select,
  Option,
  Button,
  Checkbox,
  Textarea,
  Typography,
} from "@material-tailwind/react";
import DataTable from "react-data-table-component";
import { v4 as uuid } from "uuid";
import { BiCommentError, BiSolidMessageSquareAdd } from "react-icons/bi";
import {
  BsPersonSquare,
  BsFileImage,
  BsFileEarmarkArrowUpFill,
} from "react-icons/bs";
import { FaMicrophoneAlt } from "react-icons/fa";
import { FaCheck, FaCheckDouble } from "react-icons/fa6";
import { HiUserGroup } from "react-icons/hi2";
import {
  IoSendSharp,
  IoClose,
  IoReload,
  IoWarningSharp,
} from "react-icons/io5";
import { ImAttachment } from "react-icons/im";
import { MdVideoLibrary, MdAudiotrack } from "react-icons/md";
import { RiTimer2Fill, RiContactsFill } from "react-icons/ri";
import { TbClockPlus } from "react-icons/tb";
import { TfiMenuAlt } from "react-icons/tfi";
import { toast } from "react-toastify";
import { parsePhoneNumber } from "awesome-phonenumber";

import { colorsConfig } from "../config/colorsConfig";
import { uploadLimits, wabaAcceptedInputTypes } from "../config/appConfig";
import {
  uploadMediaOnAWS,
  EnumFileUploadStatus,
} from "../helpers/AWSService.js";
import { useConversationContext } from "../contexts/ConversationContextProvider";
import { useUserContext } from "../contexts/UserContextProvider";
import { useWhatsappContext } from "../contexts/WhatsappContextProvider";
import { useFollowupContext } from "../contexts/FollowupContextProvider";
import { useContactsContext } from "../contexts/ContactsContextProvider";
import { timeStamp24hrComparision } from "../components/utils/timeStamp24hrComparision";
import { viewTemplate } from "./utils/viewTemplate.js";
import { messageDateCheck } from "./utils/messageDateCheck";
import { parseText } from "./utils/parseText";
import { AssignedFollowup, RecordVoiceNote, UpdateContact } from ".";
import locationPlaceholder from "../images/props/locationPlaceholder.png";
import contactsPlaceholderImage from "../images/props/contactsPlaceholderImage.png";
import locationPlaceholderImage from "../images/props/locationPlaceholderImage.png";
import { refreshMonitorData } from "../data/messageNotifierServices";
import useSocket from "../components/utils/useSocket";

const ChatUi = () => {
  const {
    currentUserInfo,
    apiCallGetUserAgents,
    userAgentsList,
    isUserAdminOrSuperadmin,
  } = useUserContext();
  const {
    apiCallFetchAssignedContactGroups,
    assignedContactGroups,
    apiCallAssignContactToMultipleGroups,
    setIsAddToGroup,
    isAddToGroup,
    selectedGroup,
    setSelectedGroup,
    fetchContactDetailsByPhoneNumber,
  } = useContactsContext();
  const { sendDirectMessage, sendMediaMessage, sendInteractiveMessage } =
    useWhatsappContext();
  const {
    chatData,
    setChatData,
    chatContact,
    chatImage,
    setChatContact,
    setSelectedChatContactToShow,
    setChatImage,
    convGetChatMedia,
    convGetChatHistory,
    setChatHistory,
    assignChat,
    recentContactsList,
    getQuickRepliesList,
    approvedQuickReplyList,
  } = useConversationContext();
  const { socketConnection } = useSocket();
  const { addContactFollowup } = useFollowupContext();

  const [messageValue, setMessageValue] = useState("");
  const [interactiveHeaderValue, setInteractiveHeaderValue] = useState("");
  const [interactiveBodyValue, setInteractiveBodyValue] = useState("");
  const [interactiveFooterValue, setInteractiveFooterValue] = useState("");
  const [interactiveButtonTextValue, setInteractiveButtonTextValue] =
    useState("");
  const [interactiveButtonUrlValue, setInteractiveButtonUrlValue] =
    useState("");
  const [attachment, setAttachment] = useState(false);
  const [isInteractiveMessage, setIsInteractiveMessage] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState("");
  const [mediaFormData, setMediaFormData] = useState();

  const [isAddNewContact, setIsAddNewContact] = useState(false);
  const [toAssignThisChat, setToAssignThisChat] = useState(false);
  const [toFollowUp, setToFollowUp] = useState(false);
  const [toTakeFollowUp, setTakeToFollowUp] = useState(false);
  const [toQuickReply, setToQuickReply] = useState(false);
  const [quickReplyFilterArray, setQuickReplyFilterArray] = useState([]);
  const [preSelectedAgentForChatAssign, setPreSelectedAgentForChatAssign] =
    useState([]);
  const [contactInfoForEdit, setContactInfoForEdit] = useState({});
  const [followupRemarks, setFollowupRemarks] = useState("");
  const [followupBy, setFollowupBy] = useState(0);
  const [followupCheck, setFollowupCheck] = useState("");

  const [recordVoiceNote, setRecordVoiceNote] = useState(false);
  const [loadFollowupCounter, setLoadFollowupCounter] = useState(0);

  // Function to call API and open drawer when data is ready
  const handleOpenDrawer = (e) => {
    e.preventDefault();
    setLoadFollowupCounter((prvCounter) => prvCounter + 1);
    setTakeToFollowUp(true);
  };

  const addHoursToCurrentDateTime = (hours) => {
    let date = new Date();

    // Convert hours to minutes (e.g., 2.5 hours * 60 = 150 minutes)
    const totalMinutes = hours * 60;
    date.setMinutes(date.getMinutes() + totalMinutes);
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());

    return date?.toISOString()?.substring(0, 16);
  };

  const [selectedFollowupDateTime, setSelectedFollowupDateTime] = useState(
    addHoursToCurrentDateTime(1)
  );

  let lastReceivedMessageTimeFlag = false;
  let timeStamp24hrComparisionResult = false;
  let currentMessageDateFlag = "";
  let selectedAgentForChatAssign = [];

  const convertToLocalTime = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const resetOnClick = () => {
    setMessageValue("");
    setInteractiveHeaderValue("");
    setInteractiveBodyValue("");
    setInteractiveButtonTextValue("");
    setInteractiveButtonUrlValue("");
    setInteractiveFooterValue("");
    setAttachment(false);
    setIsInteractiveMessage(false);
    setSelectedMedia("");
    setMediaFormData();
    selectedAgentForChatAssign = [];
    setPreSelectedAgentForChatAssign([]);
  };

  const submitInteractiveMessage = (e) => {
    e.preventDefault();
    const sendMessageTo = chatContact?._id;
    sendInteractiveMessage(
      sendMessageTo,
      interactiveHeaderValue,
      interactiveBodyValue,
      interactiveFooterValue,
      interactiveButtonTextValue,
      interactiveButtonUrlValue
    );
    setIsInteractiveMessage(false);
    resetOnClick();
  };

  const sendDirectMessageAndReset = () => {
    const sendMessageTo = chatContact?._id;
    sendDirectMessage(sendMessageTo, messageValue);
    resetOnClick();
    setTimeout(() => convGetChatHistory(chatContact?._id), 1500);
  };

  // To prevent next line when Enter is pressed and send the message
  const handleMessageSendOnKeyDown = (event) => {
    if (event.key === "Enter" && event.shiftKey === true) {
      return;
    }

    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
      sendDirectMessageAndReset();
    }
  };

  const selectMultipleGroup = (event, selectedData) => {
    const isChecked = event.target.checked;
    setSelectedGroup((prevSelectedGroup) => {
      const updatedSelectedGroup = isChecked
        ? [...prevSelectedGroup, selectedData]
        : prevSelectedGroup.filter((data) => data !== selectedData);
      return updatedSelectedGroup;
    });
  };

  const assignToGroupOnClick = async () => {
    let groupArray = [];
    selectedGroup?.map((groupId) => groupArray.push({ group_id: groupId }));
    const resp = await apiCallAssignContactToMultipleGroups(
      chatContact?._id,
      groupArray
    );

    if (resp) {
      setIsAddToGroup(false);
    }
  };

  const handleMessageSendButtonClick = (event) => {
    event.preventDefault();
    sendDirectMessageAndReset();
  };

  const mediaUploadOnChange = async (event) => {
    try {
      event.preventDefault();
      const uploadedFile = event.target.files[0];

      if (!uploadedFile) return;

      const inputType = event.target.id.replace("-button", ""); // Extract input type from ID
      const allowedTypes =
        wabaAcceptedInputTypes[
          inputType === "file" ? "document" : inputType
        ]?.split(", ") || [];
      const maxSize =
        uploadLimits[inputType === "file" ? "document" : inputType] || 0;

      // Validate file type
      if (!allowedTypes.includes(uploadedFile?.type)) {
        toast.error(
          `Invalid file type! Allowed: ${wabaAcceptedInputTypes[inputType]}`
        );
        event.target.value = ""; // Reset input field
        return;
      }

      // Validate file size
      if (uploadedFile?.size > maxSize) {
        toast.error(`Please select a file under ${maxSize / 1024 / 1024} MB.`);
        event.target.value = ""; // Reset input field
        return;
      }

      setSelectedMedia(uploadedFile?.name);

      const uniqueId = uuid();
      const uniqueFileName = `${uniqueId}.${uploadedFile?.name
        .split(".")
        .pop()
        .toLowerCase()}`;

      const uploadParams = {
        fileName: uniqueFileName,
        mediaFile: uploadedFile,
        fileType: uploadedFile.type,
      };

      let response = await uploadMediaOnAWS(uploadParams);
      if (response === EnumFileUploadStatus.FileUploadSuccess) {
        const sendMessageTo = chatContact?._id;

        let formData = new FormData();

        formData = {
          sendTo: sendMessageTo,
          fileName: uniqueFileName,
          fileMimeType: uploadedFile.type,
          fileExtension: uploadedFile?.name.split(".").pop().toLowerCase(),
        };
        setMediaFormData(formData);
      } else {
        console.error("File upload on cloud failed!");
      }
    } catch (err) {
      console.error("File upload error", err);
    }
  };

  const onCancelMediaUpload = () => {
    setSelectedMedia("");
    setMediaFormData();
    document.querySelector("#image-button").value = "";
  };

  const handleMediaSendOnSubmit = async (event) => {
    event.preventDefault();

    const response = await sendMediaMessage(mediaFormData);
    if (response) {
      setTimeout(() => convGetChatHistory(chatContact?._id), 1500);
    }

    resetOnClick();
  };

  const handleAssignChatOnSubmit = (event) => {
    event.preventDefault();
    const phoneNumber = chatContact?._id;
    assignChat(phoneNumber, selectedAgentForChatAssign);
    setToAssignThisChat(false);
    selectedAgentForChatAssign = [];
    setPreSelectedAgentForChatAssign([]);
  };

  const handleFollowUpOnSubmit = (event) => {
    event.preventDefault();

    if (followupBy === 0) {
      setFollowupCheck("Please select the Follow-Up by");
      return;
    } else if (
      followupBy > 0 &&
      chatContact?._id !== "" &&
      followupRemarks !== ""
    ) {
      addContactFollowup({
        contactNumber: chatContact?._id,
        followupBy: followupBy,
        followupOn: selectedFollowupDateTime,
        followupRemarks: followupRemarks,
      });
      setToFollowUp(false);
      setFollowupBy("");
      setFollowupRemarks("");
      setFollowupCheck("");
    }
  };

  const handleScroll = (e) => {
    // Prevent scrolling from bubbling up to parent elements
    e.stopPropagation();
  };
  // ******************** View Message ********************

  const viewMessage = (message, messageType) => {
    if (message?.type === "text") {
      if (typeof message?.text?.body === "string") {
        return message?.text?.body.startsWith("REACTION")
          ? message?.text?.body.slice(-2)
          : parseText(message?.text?.body);
      }
      return "Unsupported Text Message";
    } else if (message?.type === "template") {
      return (
        <div className="mt-1 text-sm -space-y-1">
          {(() => {
            let parsedMessageBody;

            try {
              parsedMessageBody =
                typeof message?.messageBody === "string"
                  ? JSON.parse(message.messageBody)
                  : message?.messageBody;
            } catch (err) {
              console.error("Invalid JSON in messageBody:", err);
              return <p className="text-red-500">Invalid message format</p>;
            }

            const components = parsedMessageBody?.components;
            const fileUrl =
              message?.template?.components?.[0]?.parameters?.[0]?.image?.link;
            if (components) {
              return (
                <>
                  <p className="mb-3 font-semibold">
                    {message?.template?.name}
                  </p>

                  {components.map((element, index) => {
                    // Clone the element to avoid mutating original array (optional but safer)
                    const updatedElement = { ...element };
                    if (
                      updatedElement?.type === "HEADER" &&
                      updatedElement?.format === "IMAGE"
                    ) {
                      if (!updatedElement.example) {
                        updatedElement.example = {};
                      }
                      if (
                        !Array.isArray(updatedElement.example.header_handle)
                      ) {
                        updatedElement.example.header_handle = [];
                      }
                      updatedElement.example.header_handle[0] = fileUrl;
                    }

                    return (
                      <React.Fragment key={index}>
                        {viewTemplate(updatedElement, true)}
                      </React.Fragment>
                    );
                  })}
                </>
              );
            } else {
              return (
                <>
                  <p className="italic">Message Template</p>
                  <p className="font-semibold">{message?.template?.name}</p>
                  <p>{message?.template?.language?.code}</p>
                </>
              );
            }
          })()}
        </div>
      );
    } else if (message?.type === "image") {
      return (
        <>
          <div
            className={`bg-[url(../src/images/props/imagePlaceholder.png)] bg-cover relative  ${
              message?.image?.id ? "w-[200px]" : "w-[450px]"
            } ${message?.image?.id ? "h-[90px]" : "h-[300px]"} mb-1`}
          >
            {message?.image?.id && (
              <button
                onClick={() => convGetChatMedia(message?.image?.id)}
                className="my-button-style-4 absolute top-7 right-8 p-2 hover:text-wabmGreen text-xs"
              >
                View
              </button>
            )}

            {message?.image?.link && (
              <img
                src={message?.image?.link}
                className="w-[440px] h-auto rounded-md"
                alt=""
              />
            )}
          </div>
          <p>{message?.image?.caption}</p>
        </>
      );
    } else if (message?.type === "document") {
      return (
        <div className="bg-[url(../src/images/props/documentPlaceholder.png)] bg-cover relative w-[210px] h-[90px]">
          <button
            onClick={() => convGetChatMedia(message?.document?.id)}
            className="my-button-style-4 absolute top-7 right-4 p-2 hover:text-wabmGreen text-xs"
          >
            Download
          </button>
        </div>
      );
    } else if (message?.type === "audio") {
      return (
        <div className="bg-[url(../src/images/props/audioPlaceholder.png)] bg-cover relative w-[210px] h-[90px]">
          <button
            onClick={() => convGetChatMedia(message?.audio?.id)}
            className="my-button-style-4 absolute top-7 right-4 p-2 hover:text-wabmGreen text-xs"
          >
            Download
          </button>
        </div>
      );
    } else if (message?.type === "contacts") {
      return (
        <div className="space-y-2 min-w-[210px]">
          {message?.contacts?.map((contact, index) => (
            <div
              key={index}
              className="w-full flex flex-col justify-center items-center gap-2"
            >
              <div className="w-full ml-2 p-2 border-2 bg-wabmBlue bg-opacity-50 rounded-md">
                <p className="font-bold">{contact?.name?.formatted_name}</p>
                <span className="space-y-1">
                  {contact?.phones?.map((phone, idx) => (
                    <span key={idx}>
                      <p>{phone?.phone}</p>
                      <p className="text-xs">( {phone?.type} )</p>
                    </span>
                  ))}
                </span>
              </div>
              <img src={contactsPlaceholderImage} alt="my-contact" />
            </div>
          ))}
        </div>
      );
    } else if (message?.type === "video") {
      return (
        <div className="bg-[url(../src/images/props/videoPlaceholder.png)] bg-cover relative w-[210px] h-[90px]">
          <button
            onClick={() => convGetChatMedia(message?.video?.id)}
            className="my-button-style-4 absolute top-7 right-4 p-2 hover:text-wabmGreen text-xs"
          >
            Download
          </button>
        </div>
      );
    } else if (message?.type === "location") {
      if (messageType === "received") {
        const locUrl = `https://maps.google.com/maps?q=${message?.location?.latitude} ${message?.location?.longitude}&output=embed`;
        return (
          <div className="w-full flex flex-col justify-center items-center gap-2">
            <a
              href={message?.location?.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full ml-2 p-2 bg-wabmBlue bg-opacity-50 hover:bg-opacity-70 rounded-md transition duration-300 ease-in-out"
            >
              <p className="break-words">
                {message?.location?.address}, {message?.location?.name}
              </p>
            </a>
            <iframe title="received-location" src={locUrl}></iframe>
            <img src={locationPlaceholderImage} alt="received location" />
          </div>
        );
      } else {
        return (
          <img
            src={locationPlaceholder}
            className="w-full px-1 rounded-md"
            alt="location placeholder"
          />
        );
      }
    } else if (message?.type === "interactive") {
      if (messageType === "received") {
        return (
          <div>
            {message?.interactive?.type === "list_reply" ? (
              <div className="">
                <p className="italic">List Reply</p>
                <p>{message?.interactive?.list_reply?.title}</p>
                <p>{message?.interactive?.list_reply?.description}</p>
              </div>
            ) : message?.interactive?.type === "button_reply" ? (
              <div className="flex flex-col gap-y-1">
                <span className="bg-wabmBlue bg-opacity-50 px-3 py-2 text-xs rounded-md">
                  {message?.interactive?.button_reply?.title}
                </span>
                <span>{message?.interactive?.button_reply?.title}</span>
              </div>
            ) : message?.interactive?.type === "nfm_reply" ? (
              <div className="flex flex-col gap-y-1">
                <span className="font-semibold rounded-md">
                  Reply : {message?.interactive?.nfm_reply?.name}
                </span>
                <span className="bg-black px-3 py-2 rounded-md text-sm text-white">
                  {message?.interactive?.nfm_reply?.response_json}
                </span>
              </div>
            ) : (
              <div>Message : {message?.interactive?.type}</div>
            )}
          </div>
        );
      } else {
        return (
          <div className="">
            {message?.interactive?.type === "list" ? (
              <div className="space-y-1">
                <p className="italic">List Message</p>
                <p>{message?.interactive?.body?.text}</p>
                <p className="inline-flex items-center gap-2">
                  <TfiMenuAlt /> {message?.interactive?.action?.button}
                </p>
                {message?.interactive?.footer && (
                  <p className="text-xs">
                    {message?.interactive?.footer?.text}
                  </p>
                )}
              </div>
            ) : message?.interactive?.type === "button" ? (
              <div className="space-y-1">
                <p className="italic">Interactive Button Message</p>
                <p>{message?.interactive?.body?.text}</p>
                {message?.interactive?.action?.buttons?.map((button, index) => (
                  <div
                    key={index}
                    className="bg-white bg-opacity-50 px-3 py-2 text-xs text-center rounded-md"
                  >
                    {button?.type === "reply"
                      ? button?.reply?.title
                      : "_unknown_reply_"}
                  </div>
                ))}
              </div>
            ) : (
              <div>Some Interactive Message</div>
            )}
          </div>
        );
      }
    } else if (message?.type === "button") {
      return (
        <div className="flex flex-col gap-y-1">
          {message?.templateName && (
            <div>
              <p className="italic">Message Template</p>
              <p className="font-semibold">{message?.templateName}</p>
            </div>
          )}
          <span className="bg-wabmBlue bg-opacity-50 px-3 py-2 text-xs rounded-md">
            {message?.button && message?.button?.payload
              ? message?.button?.payload
              : "Unsupported Button"}
          </span>
        </div>
      );
    } else if (message?.type === "order") {
      let orderPrice = 0;
      let itemCurrency = "";

      return (
        <div className="mt-1 flex flex-col gap-2 -space-y-1 text-sm rounded-md">
          {message?.order?.product_items?.map((item, index) => {
            const isImageEmpty = !item?.image_url;
            itemCurrency = item?.currency;
            orderPrice = (orderPrice + item?.item_price).toFixed(2);
            return (
              <div key={index} className="flex flex-col gap-2">
                {item?.image_url ? (
                  <img
                    className="w-48 h-48"
                    src={item?.image_url}
                    alt={item?.name}
                  />
                ) : (
                  <div
                    className={`flex flex-row justify-start gap-1 ${
                      isImageEmpty
                        ? "bg-[url(../src/images/props/imagePlaceholder.png)] bg-cover relative w-[210px] h-[90px] mb-1"
                        : ""
                    }`}
                  />
                )}
                {item?.name && (
                  <div className="flex flex-row justify-start gap-1">
                    <div className="font-bold mr-1">Item Name:</div>
                    <div className="font-bold text-md">{item?.name}</div>
                  </div>
                )}
                <div className="flex flex-row justify-start gap-1">
                  <div className="font-bold mr-1">Item ID:</div>
                  <div className="font-bold text-md">
                    {item?.product_retailer_id}
                  </div>
                </div>
                <div className="flex flex-row justify-start gap-1">
                  <div className="font-bold mr-1">Price:</div>
                  <div>
                    {item?.item_price?.toFixed(2)} {item?.currency}
                  </div>
                </div>
              </div>
            );
          })}
          <div className="flex flex-row justify-start gap-1">
            <div className="font-bold mr-1">Total Price:</div>
            <div>
              {orderPrice} {itemCurrency}
            </div>
          </div>
        </div>
      );
    } else {
      console.log("ChatUi unsupported message", message);
      return <BiCommentError size={28} color="red" />;
    }
  };

  // ******************** END OF View Message ********************

  const socketMessageListener = (messageData) => {
    let msg = null;
    if (messageData?.type === "messageReceived") {
      msg = messageData?.message;
    } else {
      msg = messageData?.message;
    }
    if (msg?.recipient_id) {
      // Update message status only
      setChatData((prevChat) => {
        const chatMap = new Map(prevChat.map((chat) => [chat?.id, chat]));
        if (chatMap.has(msg?.id)) {
          // Update only specific fields, keeping other properties intact
          chatMap.set(msg?.id, {
            ...chatMap.get(msg?.id),
            messageStatus: msg?.status,
          });
        } else {
          convGetChatHistory(chatContact?._id);
        }
        return [...Array.from(chatMap.values()), {}];
      });
    } else if (
      msg?.messaging_product?.messages?.length > 0 &&
      chatContact?._id === msg?.messaging_product?.messages?.[0]?.from
    ) {
      // Add new received message
      setChatData((prevChat) => {
        // Remove any existing instance of the new message and any blank objects (empty objects)
        const filteredChat = prevChat.filter(
          (chat) =>
            chat?.id !== msg?.messaging_product?.messages?.[0]?.id &&
            // Remove any blank objects (assuming blank objects have no keys)
            chat &&
            Object.keys(chat).length > 0
        );
        // Create a new message object
        const newMessage = { ...msg?.messaging_product?.messages[0] };
        // Return the new state: new message at the top, then a blank object, then the rest
        return [newMessage, ...filteredChat];
      });
    } else {
      // console.log("Chat UI socket | else | msg", msg);
    }

    refreshMonitorData?.next({ msg, selectedContact: chatContact?._id });
  };

  const agentTableColumns = [
    {
      name: "Agent User Name",
      selector: (row) => row?.agentUsername,
      sortable: true,
    },
    {
      name: "Agent Name",
      selector: (row) => row?.agentFullName,
      sortable: true,
    },
    {
      name: "Agent Email",
      selector: (row) => row?.agentEmail,
      sortable: true,
    },
  ];

  const handleChange = ({ selectedRows }) => {
    selectedAgentForChatAssign = [];
    selectedRows?.map((x) => selectedAgentForChatAssign.push(x.agentId));
  };

  const previouslyAssignedContactGroup = async () => {
    const result = await apiCallFetchAssignedContactGroups(chatContact?._id);
    return result;
  };

  const preAssignedAgent = (row) =>
    preSelectedAgentForChatAssign.includes(row.agentId);

  useEffect(() => {}, [chatData]);
  useEffect(() => {}, [selectedMedia]);
  useEffect(() => {
    apiCallGetUserAgents();
    getQuickRepliesList("approved"); // Get approved quick replies
    setQuickReplyFilterArray(approvedQuickReplyList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRowClick = (value) => {
    setMessageValue(value);
    setToQuickReply(false);
  };

  useEffect(() => {
    if (chatContact && socketConnection?.connected) {
      socketConnection.on(currentUserInfo?.wabPhoneId, socketMessageListener);
    }

    return () => {
      if (socketConnection) {
        socketConnection.off(
          currentUserInfo?.wabPhoneId,
          socketMessageListener
        );
      }
    };
  });

  return (
    <div className="h-[60vh] md:h-screen flex flex-col justify-between overflow-y-auto">
      {chatContact !== "" && (
        <>
          <Drawer
            placement="right"
            open={isAddNewContact}
            onClose={() => setIsAddNewContact(false)}
            size="700px"
            className="w-full p-4"
          >
            <button
              type="button"
              onClick={() => setIsAddNewContact(false)}
              className="my-button-style-cancel"
            >
              <IoClose size={18} />
            </button>
            <UpdateContact
              contactInfo={contactInfoForEdit}
              setUpdateContact={setIsAddNewContact}
              isAddUpdateContact={isAddNewContact}
            />
          </Drawer>

          <Drawer
            placement="right"
            open={recordVoiceNote}
            onClose={() => setRecordVoiceNote(false)}
            size="500px"
            className="w-full p-4"
          >
            <button
              type="button"
              onClick={() => setRecordVoiceNote(false)}
              className="my-button-style-cancel"
            >
              <IoClose size={18} />
            </button>
            <RecordVoiceNote
              setRecordVoiceNote={setRecordVoiceNote}
              sendMessageTo={chatContact?._id}
            />
          </Drawer>

          <div className="bg-wabmAiBlue w-full px-3 py-2 flex justify-between items-center gap-3 text-white text-sm">
            <div className="flex items-center gap-5">
              <BsPersonSquare size={36} />
              <div>
                {chatContact?.fullName !== "" &&
                chatContact?.fullName !== undefined ? (
                  <h2 className="font-bold">{chatContact?.fullName}</h2>
                ) : chatContact?.profile?.name !== undefined ? (
                  <h3 className="text-md">( {chatContact?.profile?.name} )</h3>
                ) : (
                  <></>
                )}
                <h3>+{chatContact?._id}</h3>
              </div>
            </div>
            <div className="flex items-center gap-2">
              {(isUserAdminOrSuperadmin() ||
                (chatContact?.assignedUser &&
                  JSON.parse(chatContact?.assignedUser).indexOf(
                    currentUserInfo?.agentId
                  ) !== -1)) && (
                <button
                  title="Click to Assign Chat"
                  onClick={() => {
                    let recentChatData = recentContactsList.find(
                      (x) => x._id === chatContact?._id
                    );
                    if (
                      recentChatData &&
                      recentChatData.assignedUser &&
                      JSON.parse(recentChatData.assignedUser).length > 0
                    ) {
                      setPreSelectedAgentForChatAssign(
                        JSON.parse(recentChatData.assignedUser)
                      );
                    }
                    apiCallGetUserAgents();
                    setToAssignThisChat(true);
                  }}
                  className="my-hover-effect text-white"
                >
                  <BiSolidMessageSquareAdd size={26} />
                </button>
              )}
              {(isUserAdminOrSuperadmin() ||
                currentUserInfo?.canAccessFollowUps === 1) && (
                <button
                  title="Click to Add a Follow-Up"
                  onClick={() => setToFollowUp(true)}
                  className="my-hover-effect text-white"
                >
                  <TbClockPlus size={28} />
                </button>
              )}
              {(isUserAdminOrSuperadmin() ||
                currentUserInfo?.canAccessFollowUps === 1) && (
                <button
                  title="Check Follow-Ups"
                  onClick={(e) => {
                    handleOpenDrawer(e);
                  }}
                  className="my-hover-effect text-white"
                >
                  <RiTimer2Fill size={28} />
                </button>
              )}
              <button
                title="Add/Update Contact"
                onClick={async () => {
                  const response = await fetchContactDetailsByPhoneNumber(
                    chatContact?._id
                  );

                  if (response) {
                    if (response?.[0]?.ContactId > 0) {
                      setContactInfoForEdit(response[0]);
                      setIsAddNewContact(true);
                    } else {
                      const parsedNumber = parsePhoneNumber(
                        "+" + chatContact?._id
                      );

                      if (parsedNumber?.valid) {
                        setContactInfoForEdit({
                          ContactId: 0,
                          FirstName: "",
                          LastName: "",
                          Email: "",
                          waOptIn: 0,
                          IsBlocked: 0,
                          Remarks: "",
                          CompanyName: "",
                          City: "",
                          Country: "",
                          CountryCode: parsedNumber?.countryCode,
                          PhoneNumber: parsedNumber?.number.significant,
                        });
                        setIsAddNewContact(true);
                      } else {
                        toast.success("Phone number is invalid");
                      }
                    }
                  }
                }}
                className="my-hover-effect text-white"
              >
                <RiContactsFill size={24} />
              </button>
              <button
                title="Add to Contact group"
                onClick={async () => await previouslyAssignedContactGroup()}
                className="my-hover-effect text-white"
              >
                <HiUserGroup size={28} />
              </button>
            </div>
            <div className="flex items-center gap-2">
              <button
                title="Click to refresh chat"
                onClick={() => convGetChatHistory(chatContact?._id)}
                className="my-hover-effect text-white"
              >
                <IoReload size={28} />
              </button>
              <button
                title="Close chat window"
                onClick={() => {
                  setSelectedChatContactToShow("");
                  setChatContact("");
                  setChatHistory(false);
                }}
                className="my-button-style-4 hover:text-red-600 h-fit"
              >
                <IoClose size={24} />
              </button>
            </div>
          </div>

          {chatImage && chatImage !== "" && (
            <div className="my-full-screen-window-style-1 flex items-center z-50">
              <img
                src={chatImage}
                alt="chat pic"
                className="max-w-screen max-h-screen mx-auto"
              />
              <button
                onClick={() => setChatImage("")}
                className="my-button-style-cancel absolute top-5 right-5"
              >
                <IoClose size={18} />
              </button>
            </div>
          )}

          <div className="w-full h-full px-5 py-2 flex flex-col-reverse gap-3 overflow-y-scroll">
            {chatData?.map((chat, index) => {
              const messageDateCheckValue = messageDateCheck(
                chat?.timestamp
              ).toString();
              let isDateDisplay = false;
              let timeStampToDisplay = "";
              let messageBody = [];

              if (currentMessageDateFlag === "") {
                currentMessageDateFlag = messageDateCheckValue;
              } else if (currentMessageDateFlag !== messageDateCheckValue) {
                timeStampToDisplay = currentMessageDateFlag;
                isDateDisplay = true;
                currentMessageDateFlag = messageDateCheckValue;
              }

              if (chat?.from) {
                if (lastReceivedMessageTimeFlag === false) {
                  timeStamp24hrComparisionResult = timeStamp24hrComparision(
                    chat?.timestamp
                  );
                  lastReceivedMessageTimeFlag = true;
                }

                return (
                  <React.Fragment key={chat?._id}>
                    {isDateDisplay && timeStampToDisplay !== "" && (
                      <p className="bg-slate-200 mx-auto px-2 py-1 text-xs rounded">
                        {timeStampToDisplay}
                      </p>
                    )}
                    {index < chatData?.length - 1 && (
                      <div className="flex justify-start">
                        <div className="my-message-received">
                          <p className="whitespace-pre-line mb-2">
                            {viewMessage(chat, "received")}
                          </p>
                          {messageBody?.length > 0 && (
                            <div className="bg-white rounded-md">
                              {messageBody?.map((element) =>
                                viewTemplate(element)
                              )}
                            </div>
                          )}
                          <div className="left-1 bottom-0 text-[10px] text-slate-600">
                            {convertToLocalTime(chat?.timestamp)}
                          </div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                );
              } else if (chat?.to) {
                return (
                  <React.Fragment key={chat?._id}>
                    {isDateDisplay && timeStampToDisplay !== "" && (
                      <p className="bg-slate-200 mx-auto px-2 py-1 text-xs rounded">
                        {timeStampToDisplay}
                      </p>
                    )}
                    {index < chatData?.length - 1 && (
                      <div className="relative flex justify-end">
                        <div className="my-message-sent">
                          <span
                            title={chat?.agent ? chat?.agent : "Unknown"}
                            className={`${
                              chat?.agent === currentUserInfo?.agentName
                                ? "bg-infokeyYellow text-black"
                                : "bg-wabmGreen"
                            } w-6 h-6 p-1 absolute -top-3 -right-1 text-center text-xs font-bold rounded-full z-10`}
                          >
                            {chat?.agent ? chat?.agent.charAt(0) : "!"}
                          </span>

                          <p className="whitespace-pre-line mb-2">
                            {viewMessage(chat, "sent")}
                          </p>
                          {messageBody?.length > 0 && (
                            <div className="bg-white rounded-md">
                              {messageBody?.map((element) =>
                                viewTemplate(element)
                              )}
                            </div>
                          )}
                          <div className="flex justify-between items-center gap-5 text-slate-600">
                            <p className="text-[10px]">
                              {convertToLocalTime(chat?.timestamp)}
                            </p>
                            <span>
                              {chat?.messageStatus === "sent" ? (
                                <FaCheck
                                  title="Sent"
                                  className="text-slate-400"
                                />
                              ) : chat?.messageStatus === "delivered" ? (
                                <FaCheckDouble
                                  title="Delivered"
                                  className="text-slate-400"
                                />
                              ) : chat?.messageStatus === "read" ? (
                                <FaCheckDouble
                                  title="Read"
                                  className="text-green-500"
                                />
                              ) : chat?.messageStatus === "failed" ? (
                                <IoClose
                                  title={`${
                                    chat?.errorMessage
                                      ? chat?.errorMessage
                                      : "Failed"
                                  }`}
                                  className="text-red-600"
                                />
                              ) : (
                                <IoWarningSharp
                                  title="Status Unknown"
                                  className="text-amber-400"
                                />
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                );
              }
              return <></>;
            })}
          </div>

          {timeStamp24hrComparisionResult ? (
            <div className="bg-green-200 w-full p-2 relative flex gap-2">
              {(chatContact?.assignedUser &&
                JSON.parse(chatContact?.assignedUser).indexOf(
                  currentUserInfo?.agentId
                ) !== -1) ||
              currentUserInfo?.isAdmin === 1 ||
              currentUserInfo?.isAdmin === 2 ? (
                <>
                  {attachment ? (
                    <button
                      type="button"
                      onClick={() => setAttachment(!attachment)}
                      className="my-button-style-1 h-full text-wabmGreen"
                    >
                      <ImAttachment />
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={() => setAttachment(!attachment)}
                      className="my-button-style-1 h-full"
                    >
                      <ImAttachment />
                    </button>
                  )}
                  <button
                    onClick={() => setRecordVoiceNote(true)}
                    className="my-button-style-1"
                  >
                    <FaMicrophoneAlt />
                  </button>
                  {attachment ? (
                    <div className="w-full h-10 flex justify-between">
                      <form
                        onSubmit={handleMediaSendOnSubmit}
                        className="flex gap-2"
                      >
                        {selectedMedia !== "" && (
                          <div className="my-card-style-2 absolute bottom-12 left-0 z-50 flex justify-between items-center gap-5">
                            <h3 className="text-white font-bold">
                              {selectedMedia}
                            </h3>
                            <span className="flex gap-2">
                              <button
                                onClick={onCancelMediaUpload}
                                className="my-button-style-4 px-3"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                className="my-button-style-1"
                              >
                                <IoSendSharp />
                              </button>
                            </span>
                          </div>
                        )}
                        <input
                          accept={wabaAcceptedInputTypes.image}
                          max={uploadLimits.image}
                          id="image-button"
                          type="file"
                          onChange={mediaUploadOnChange}
                          className="hidden"
                        />
                        <label
                          htmlFor="image-button"
                          className="my-button-style-4 px-3 py-2 grid place-items-center cursor-pointer"
                        >
                          <BsFileImage />
                        </label>

                        <input
                          accept={wabaAcceptedInputTypes.video}
                          max={uploadLimits.video}
                          id="video-button"
                          type="file"
                          onChange={mediaUploadOnChange}
                          className="hidden"
                        />
                        <label
                          htmlFor="video-button"
                          className="my-button-style-4 px-3 py-2 grid place-items-center cursor-pointer"
                        >
                          <MdVideoLibrary />
                        </label>

                        <input
                          accept={wabaAcceptedInputTypes.audio}
                          max={uploadLimits.audio}
                          id="audio-button"
                          type="file"
                          onChange={mediaUploadOnChange}
                          className="hidden"
                        />
                        <label
                          htmlFor="audio-button"
                          className="my-button-style-4 px-3 py-2 grid place-items-center cursor-pointer"
                        >
                          <MdAudiotrack />
                        </label>

                        <input
                          accept={wabaAcceptedInputTypes.document}
                          max={uploadLimits.document}
                          id="file-button"
                          type="file"
                          onChange={mediaUploadOnChange}
                          className="hidden"
                        />
                        <label
                          htmlFor="file-button"
                          className="my-button-style-4 px-3 py-2 grid place-items-center cursor-pointer"
                        >
                          <BsFileEarmarkArrowUpFill />
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            setInteractiveBodyValue("");
                            setInteractiveHeaderValue("");
                            setInteractiveFooterValue("");
                            setInteractiveButtonTextValue("");
                            setInteractiveButtonUrlValue("");
                            setIsInteractiveMessage(true);
                          }}
                          className="my-button-style-4 px-3 py-2 text-black"
                        >
                          Send Interactive Message
                        </button>
                        <button
                          onClick={() => setAttachment(false)}
                          className="my-button-style-4 px-3 py-2 text-black"
                        >
                          Type a Message
                        </button>
                      </form>
                    </div>
                  ) : (
                    <form className="w-full h-10 flex gap-2">
                      <textarea
                        cols="25"
                        rows="2"
                        value={messageValue}
                        onChange={(e) => {
                          if (/^\/\S*$/.test(e.target.value)) {
                            setToQuickReply(true);
                            if (
                              approvedQuickReplyList &&
                              approvedQuickReplyList.length > 0
                            ) {
                              let filterQuickReply =
                                approvedQuickReplyList?.filter(
                                  (el) =>
                                    el?.isApproved === 1 &&
                                    el?.quickReplyText
                                      .toLowerCase()
                                      .includes(
                                        e.target.value
                                          .toLowerCase()
                                          .replace("/", "")
                                      )
                                );
                              setQuickReplyFilterArray(filterQuickReply);
                            }
                          } else {
                            setToQuickReply(false);
                          }
                          setMessageValue(e.target.value);
                        }}
                        placeholder="type your message"
                        onKeyDown={handleMessageSendOnKeyDown}
                        className="my-input-style-1 py-1 w-full h-10"
                      />
                      <button
                        onClick={handleMessageSendButtonClick}
                        className="my-button-style-1"
                      >
                        <IoSendSharp />
                      </button>
                    </form>
                  )}
                </>
              ) : (
                <div className="bg-wabmBlue w-full p-2 relative flex gap-2">
                  <p className="text-xs text-white">
                    You don't have permission to reply on this chat.
                  </p>
                </div>
              )}
            </div>
          ) : (
            <div className="bg-wabmAiBlue w-full p-2 relative flex gap-2">
              <p className="text-xs text-white">
                It's been more than 24 hrs since last received message. Please
                initiate the conversation with templates.
              </p>
            </div>
          )}
        </>
      )}

      <Dialog
        size={"lg"}
        open={toAssignThisChat}
        handler={() => setToAssignThisChat(!toAssignThisChat)}
      >
        <span className="flex justify-between gap-3">
          <DialogHeader>Assign Chat</DialogHeader>
        </span>
        <form onSubmit={handleAssignChatOnSubmit}>
          <DialogBody className="space-y-2">
            <div className="my-2 rounded-md">
              <DataTable
                columns={agentTableColumns}
                data={userAgentsList?.filter((x) => x.isBlocked === 0)}
                customStyles={agentTableStyles}
                fixedHeader
                selectableRows
                onSelectedRowsChange={handleChange}
                fixedHeaderScrollHeight="60vh"
                selectableRowSelected={preAssignedAgent}
              />
            </div>
          </DialogBody>
          <DialogFooter>
            <Button
              type="button"
              variant="text"
              color="red"
              onClick={() => {
                setToAssignThisChat(false);
              }}
              className="mr-1"
            >
              <span>Cancel</span>
            </Button>
            <Button type="submit" variant="gradient" color="green">
              <span>Confirm</span>
            </Button>
          </DialogFooter>
        </form>
      </Dialog>
      <Dialog
        className="w-72"
        open={isInteractiveMessage}
        handler={() => setIsInteractiveMessage(!isInteractiveMessage)}
      >
        <span className="flex justify-between gap-2">
          <DialogHeader>Send Interactive Message</DialogHeader>
        </span>
        <form onSubmit={submitInteractiveMessage}>
          <DialogBody>
            <div className="flex flex-row justify-start">
              <div className="flex flex-col justify-start gap-3 m-2 w-[60%]">
                <Input
                  value={interactiveHeaderValue}
                  onChange={(e) => {
                    setInteractiveHeaderValue(e.target.value);
                  }}
                  type="text"
                  variant="outlined"
                  color="green"
                  className={`${
                    interactiveHeaderValue === ""
                      ? "outline-2 outline-green-700"
                      : ""
                  }`}
                  label="Header"
                />
                <Textarea
                  type="text"
                  variant="outlined"
                  color="green"
                  required
                  label="Body"
                  value={interactiveBodyValue}
                  onChange={(e) => setInteractiveBodyValue(e.target.value)}
                  className={`${
                    interactiveBodyValue === "" ? "outline-2" : ""
                  } outline-green-700`}
                />
                <Input
                  value={interactiveFooterValue}
                  onChange={(e) => setInteractiveFooterValue(e.target.value)}
                  type="text"
                  variant="outlined"
                  color="green"
                  label="Footer"
                  className={`${
                    interactiveFooterValue === "" ? "outline-2" : ""
                  } outline-green-700`}
                />
                <Input
                  value={interactiveButtonTextValue}
                  onChange={(e) =>
                    setInteractiveButtonTextValue(e.target.value)
                  }
                  type="text"
                  required
                  variant="outlined"
                  color="green"
                  label="Button Text"
                  className={`${
                    interactiveButtonTextValue === "" ? "outline-2" : ""
                  } outline-green-700`}
                />
                <Input
                  value={interactiveButtonUrlValue}
                  onChange={(e) =>
                    setInteractiveButtonUrlValue(e.target.value?.trim())
                  }
                  type="text"
                  required
                  variant="outlined"
                  color="green"
                  label="Button URL"
                  className={`${
                    interactiveButtonUrlValue === "" ? "outline-2" : ""
                  } outline-green-700`}
                />
              </div>
              <div className="flex flex-col justify-start gap-3 m-2 w-[38%]">
                <div className="flex flex-col justify-center items-center bg-gray-100 m-4 w-full h-full rounded-lg">
                  <div>{interactiveHeaderValue}</div>
                  <div>{interactiveBodyValue}</div>
                  <div className="text-gray-400">{interactiveFooterValue}</div>
                  {interactiveButtonTextValue !== "" && (
                    <div className="mt-4">
                      <a
                        className="border-2 border-green-600 rounded-md p-3"
                        href={interactiveButtonUrlValue}
                      >
                        {interactiveButtonTextValue}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </DialogBody>
          <DialogFooter>
            <Button
              type="button"
              variant="filled"
              color="red"
              onClick={() => setIsInteractiveMessage(false)}
              className="mr-1"
            >
              <span>Cancel</span>
            </Button>

            <Button type="submit" variant="gradient" color="blue">
              <IoSendSharp />
            </Button>
          </DialogFooter>
        </form>
      </Dialog>

      <Drawer
        onScroll={handleScroll}
        placement="right"
        open={isAddToGroup}
        onClose={() => setIsAddToGroup(!isAddToGroup)}
        size="50vw"
        className="rounded-t-xl "
      >
        <span className="flex justify-between gap-2">
          <DialogHeader>
            <div className="space-y-1">
              <div className="flex gap-1">
                <p className="text-lg font-semibold">+{chatContact?._id}</p>
                {chatContact?.fullName && (
                  <h4 className="text-wabmBlue text-lg font-semibold">
                    ({chatContact?.fullName})
                  </h4>
                )}
              </div>
              <p>Assign this contact to contact group(s)</p>
            </div>
          </DialogHeader>
        </span>
        <DialogBody>
          <div className="max-h-[70vh] border rounded-md overflow-y-auto">
            {assignedContactGroups?.map((group, index) => {
              const isLast = index === assignedContactGroups.length - 1;
              const borderClass = isLast ? "" : "border-b border-blue-gray-70";

              return (
                <div
                  key={group?.groupId || index}
                  className={`flex items-center ${borderClass}`}
                >
                  <Checkbox
                    id={`group-${group?.groupId}`}
                    ripple={true}
                    checked={selectedGroup.includes(group?.groupId)}
                    onChange={(e) => selectMultipleGroup(e, group?.groupId)}
                  />
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-bold ml-2"
                  >
                    {group?.groupName}
                  </Typography>
                </div>
              );
            })}
          </div>
        </DialogBody>
        <DialogFooter>
          <Button
            type="button"
            variant="gradient"
            color="green"
            onClick={assignToGroupOnClick}
            className="w-full md:w-28"
          >
            Done
          </Button>
        </DialogFooter>
      </Drawer>

      <Dialog
        className="w-72"
        open={toFollowUp}
        handler={() => setToFollowUp(!toFollowUp)}
      >
        <span className="flex justify-between gap-2">
          <DialogHeader>Want to add a Follow Up?</DialogHeader>
        </span>
        <form onSubmit={handleFollowUpOnSubmit}>
          <DialogBody>
            <div className="flex flex-col justify-start gap-4">
              <Select
                label="Follow-Up By"
                variant="standard"
                color="blue"
                required
                valid={followupBy !== 0}
                onChange={(value) => setFollowupBy(value)}
                className="my-input-box-1"
              >
                {userAgentsList
                  ?.filter((x) => x?.isBlocked === 0)
                  .map((agent) => (
                    <Option
                      key={agent?.agentId}
                      value={agent?.agentId}
                      className={`hover:bg-blue-300 focus:bg-blue-300`}
                    >
                      {agent?.agentFullName + " (" + agent?.agentUsername + ")"}
                    </Option>
                  ))}
              </Select>
              <Input
                variant="standard"
                label="Note"
                placeholder="Eg. Check if customer has seen your proposal"
                required
                onChange={(e) => setFollowupRemarks(e.target.value)}
              />
              <span className="grid grid-cols-2 gap-3">
                <p className="border-r border-slate-400 text-sm">
                  Schedule Time
                </p>
                <input
                  type="datetime-local"
                  required
                  value={selectedFollowupDateTime}
                  onChange={(event) => {
                    setSelectedFollowupDateTime(event.target.value);
                  }}
                  min={addHoursToCurrentDateTime(0.5)}
                  max={addHoursToCurrentDateTime(1080)}
                  className="my-input-style-1"
                />
              </span>
              {followupCheck !== "" && (
                <p className="text-xs text-red-500">{followupCheck}</p>
              )}
            </div>
          </DialogBody>
          <DialogFooter>
            <Button
              type="button"
              variant="text"
              color="red"
              onClick={() => setToFollowUp(false)}
              className="mr-1"
            >
              <span>Cancel</span>
            </Button>
            <Button type="submit" variant="gradient" color="green">
              <span>Confirm</span>
            </Button>
          </DialogFooter>
        </form>
      </Dialog>

      <Drawer
        onScroll={handleScroll}
        placement="bottom"
        open={toTakeFollowUp}
        onClose={() => setTakeToFollowUp(!toTakeFollowUp)}
        size="91vh"
        className="rounded-t-xl "
      >
        <AssignedFollowup
          loadFollowup={loadFollowupCounter}
          contactNumber={chatContact?._id}
        />
      </Drawer>

      {toQuickReply && (
        <div
          className={`mb-2 mt-16 bg-zinc-50 z-[8888] absolute w-[66%] h-[84%] transition-transform duration-500 ${
            toQuickReply ? "translate-y-0" : "-translate-y-full"
          }`}
        >
          <div className="flex flex-col justify-start p-4 gap-1">
            <h1 className="text-2xl mb-3">Quick Reply</h1>
            {quickReplyFilterArray?.length > 0 &&
              quickReplyFilterArray?.map((element) => (
                <div
                  onClick={() => handleRowClick(element?.quickReplyText)}
                  className="bg-zinc-100 rounded p-2 hover:bg-blue-200 
                hover:cursor-pointer"
                >
                  {element?.quickReplyText}
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatUi;

const agentTableStyles = {
  rows: {
    style: {},
  },
  headCells: {
    style: {
      backgroundColor: colorsConfig.mediumGrey,
      color: "#FFFFFF",
      fontSize: "0.9rem",
    },
  },
  cells: {
    style: {},
  },
};
